import { set } from "lodash";

export function kvToJson(k, v) {
  const list = [];
  v.forEach((valueItem) => {
    let data = {};
    valueItem.forEach((item, index) => {
      if (Array.isArray(item)) {
        set(data, "list", {
          k: k[index],
          v: item,
        });
      } else {
        set(data, k[index], item);
      }
    });
    list.push(data);
  });
  return list;
}
